// (A) 중립 Progress API — antd 미접촉. (B) PlainProgress 에 위임.
import type { CSSProperties } from 'react'
import { PlainProgress } from '../_impl/PlainProgress'

export interface OmwProgressProps {
  percent?: number
  showInfo?: boolean
  /** 실측: Export 뷰가 exception/active 사용. */
  status?: 'normal' | 'active' | 'exception' | 'success'
  strokeColor?: string
  size?: 'small' | 'default'
  className?: string
  style?: CSSProperties
}

export function OmwProgress(props: OmwProgressProps) {
  return <PlainProgress {...props} />
}
